import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ErrorModalComponent } from './components/error-modal/error-modal.component';
import { MessageModalComponent } from './components/message-modal/message-modal.component';
import { SearchComponent } from './components/search/search.component';
import { FormsModule } from '@angular/forms';
import { QuickSearchComponent } from './components/quick-search/quick-search.component';
import { GlobalQuickSearchComponent } from './components/global-quick-search/global-quick-search.component';
import { PaymentComponent } from './components/payment/payment.component';
import { DocumentValidationComponent } from './components/document-validation/document-validation.component';
import { DocValidationComponent } from './components/doc-validation/doc-validation.component';
import { CoreModule } from '../core/core.module';
import { NewToolbarComponent } from './components/new-toolbar/new-toolbar.component';
import { SearchLegalEntitiesComponent } from './components/search-legal-entities/search-legal-entities.component';
import { CreateLegalEntityComponent } from './components/create-legal-entity/create-legal-entity.component';
import { AddSubLegalEntityComponent } from './components/add-sub-legal-entity/add-sub-legal-entity.component';
import { BreadcrumbComponent } from './components/breadcrumb/breadcrumb.component';

import { LottieModule } from 'ngx-lottie';
import player from 'lottie-web';
import { SkeletonTableComponent } from './components/skeleton-table/skeleton-table.component';
import { SkeletonListComponent } from './components/skeleton-list/skeleton-list.component';
import { ManageDocumentsComponent } from './components/manage-documents/manage-documents.component';
import { ZARCurrencyPipe } from './custom.currencypipe';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { IdentityDocValidationComponent } from './components/identity-doc-validation/identity-doc-validation.component';
import { IntlTelInputDirective } from './intl-tel-input.directive';
import { EffectsModule } from '@ngrx/effects';
import { SharedEffects } from './effects/shared.effects';
import { StoreModule } from '@ngrx/store';
import * as fromSharedReducer from './reducers';
import * as fromBusinessUserRolesReducer from './reducers/business-user-role.reducer';
import { LocalDevExtremeModule } from '../dev-extreme/dev-extreme.module';
import { DxBreadcrumbComponent } from './components/dx-breadcrumb/dx-breadcrumb.component';
import { RouterModule } from '@angular/router';
import { ProductContributionsComponent } from './components/product-contributions/product-contributions.component';
import { BankProofValidationComponent } from './components/bankproof-validation/bankproof-validation.component';
import { AddressProofValidationComponent } from './components/address-proof-validation/address-proof-validation.component';
import { TaxNumbersEffects } from './effects/tax-numbers.effects';
import { RegulationVerifiedEffects } from './effects/regulation-verified.effects';
import { TaxNumbersComponent } from './components/tax-numbers/tax-numbers.component';
import { LegalEntityHistoryComponent } from './components/legal-entity-history/legal-entity-history.component';
import { SideNavComponent } from './components/side-nav/side-nav.component';

export function playerFactory() {
  return player;
}

const COMPONENTS = [
  // ToolbarComponent,
  ErrorModalComponent,
  MessageModalComponent,
  SearchComponent,
  QuickSearchComponent,
  PaymentComponent,
  DocValidationComponent,
  BankProofValidationComponent,
  AddressProofValidationComponent,
  IdentityDocValidationComponent,
  DocumentValidationComponent,
  ManageDocumentsComponent,
  SideNavComponent,
  NewToolbarComponent,
  SearchLegalEntitiesComponent,
  CreateLegalEntityComponent,
  AddSubLegalEntityComponent,
  BreadcrumbComponent,
  DxBreadcrumbComponent,
  SkeletonTableComponent,
  SkeletonListComponent,
  ZARCurrencyPipe,
  IntlTelInputDirective,
  ProductContributionsComponent,
  TaxNumbersComponent,
  LegalEntityHistoryComponent,
  GlobalQuickSearchComponent
];

@NgModule({
  declarations: [COMPONENTS],
  exports: [COMPONENTS],
  providers: [IntlTelInputDirective],
  imports: [
    CommonModule,
    RouterModule,
    // PrimengModule,
    LocalDevExtremeModule,
    FontAwesomeModule,
    FormsModule,
    CoreModule,
    LottieModule.forRoot({ player: playerFactory }),
    StoreModule.forFeature(fromSharedReducer.sharedFeatureKey, fromSharedReducer.reducers),
    StoreModule.forFeature(fromBusinessUserRolesReducer.businessUserRoleFeatureKey, fromBusinessUserRolesReducer.reducer),
    EffectsModule.forFeature([
      SharedEffects
    ]),
    EffectsModule.forFeature([
      TaxNumbersEffects
    ]),
    EffectsModule.forFeature([
      RegulationVerifiedEffects
    ])
  ]
})
export class SharedModule {}
